module.exports = __webpack_public_path__ + "static/media/preview_ru.ecd8dade.jpg";